module.exports = __webpack_public_path__ + "static/media/hamburger_icon.bab9ad68.svg";